module.exports = __webpack_public_path__ + "static/background-ec1bab7c6f40368ededcf783ca464453.jpg";